import { Exclude, Expose, Type } from 'class-transformer'

@Exclude()
export class PopularBookSearchLogsGraph {
  @Expose() time: number

  @Expose() totalSearch: number
}
